import mapValues from "lodash/mapValues"
import parse from "html-react-parser"
import { compact, get, isEmpty, omit, remove, set, values } from "lodash"

// formatedd Today Date for Date Picker Input

// Convert Null Values in object to empty string
export function convertNullToString(object) {
  const newObject = mapValues(object, (v) => (v === null ? "" : v))
  return newObject
}

// Reset Column Filter in Table

export const resetSearchColumnInput = () => {
  const columnFilter = Array.from(document.querySelectorAll(".ColumnFilter"))

  columnFilter.length > 0 &&
    columnFilter.forEach((item) => {
      console.log("=======", item.target)
      item.value = ""
    })
}

// Check if the item is object or not
export const isItemObject = (item) => {
  if (typeof item === "object" && item !== null) {
    return true
  } else {
    return false
  }
}

// find an input based on id from an array
export const fieldFinder = (inputsArray, id) => {
  const field =
    inputsArray &&
    inputsArray?.length > 0 &&
    inputsArray.find((item) => item.id === parseInt(id))
  return field ? { ...field, label_name: parse(field?.label_name || "") } : null
}

// find an input based on id from an array
export const findInputDefaultValue = (inputsArray, id) => {
  const fieldType =
    inputsArray &&
    inputsArray.find((item) => item.id === parseInt(id))?.field_type
  return inputsArray
    ? inputsArray.find((item) => item.id === parseInt(id))?.default_value &&
      (fieldType === "dropdown".toLowerCase() ||
        fieldType === "number".toLowerCase() ||
        fieldType === "boolean".toLowerCase())
      ? parseInt(
          inputsArray.find((item) => item.id === parseInt(id))?.default_value
        )
      : inputsArray.find((item) => item.id === parseInt(id))?.default_value
    : ""
}

/**
 * Formats the size
 */
export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes"
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
}

export function convertNameToRoute(name) {
  return name.toLowerCase().replace(/\s/g, "-")
}

export function arrayReducer(array, name) {
  const reducedValue = Array.isArray(array)
    ? array.reduce(
        (total, item) => (name ? total + item[name] : total + item),
        0
      )
    : 0
  // return parseInt(reducedValue) === 0 ? 0 : (+reducedValue).toFixed(2)
  return isFloat(reducedValue) ? (+reducedValue).toFixed(2) : reducedValue
}

export function roundNumber(number) {
  return parseInt(number) === 0 || isNaN(number) || parseInt(number) < 0
    ? 0
    : (+number).toFixed(2)
}

export function isFloat(n) {
  return Number(n) === n && n % 1 !== 0
}

export function objectToValue(object, value) {
  return isItemObject(object) ? object[value] : object
}

export function isObjectValuesEmpty(object) {
  return isEmpty(compact(values(object)))
}

export function removeEmptyObject(arrayOfObjects) {
  const newArray =
    Array.isArray(arrayOfObjects) && arrayOfObjects.length > 0
      ? remove(
          arrayOfObjects.map((item) => omit(item, ["id"])),
          function (item) {
            return !isObjectValuesEmpty(item)
          }
        )
      : []
  return newArray
}

// flatten objects

export function flattenObject(ob) {
  var toReturn = {}

  for (var i in ob) {
    if (!ob.hasOwnProperty(i)) continue

    if (typeof ob[i] == "object" && ob[i] !== null) {
      var flatObject = flattenObject(ob[i])
      for (var x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue

        toReturn[i + "." + x] = flatObject[x]
      }
    }
    if (Array.isArray(ob[i]) && ob[i]?.length > 0) {
      ob[i].forEach((item) => {
        if (typeof item == "object" && item !== null) {
          var flatObject = flattenObject(item)
          for (var x in flatObject) {
            if (!flatObject.hasOwnProperty(x)) continue

            toReturn[i + "." + x] = flatObject[x]
          }
        }
      })
    } else {
      toReturn[i] = ob[i]
    }
  }

  return toReturn
}

// get the only updated values between the initial values and values
export function updatedFields(initialVal, values) {
  const flattened = flattenObject(initialVal)
  //only get the modified values to not accidentally edit old ones.
  let resultObject = {}
  Object.entries(flattened)?.map((entry) => {
    const [key, oldVal] = entry
    const newVal = get(values, key)
    if (newVal !== oldVal) {
      set(resultObject, key, newVal)
    }
  })
  return resultObject
}

export const formatNumber = (number) => {
  // Convert the number to a number
  let formattedNumber = Number(number)

  if (number === 0) {
    return 0
  }
  // Check if the conversion was successful or if the number is passed is null
  if (isNaN(formattedNumber) || !number) {
    return ""
  }

  // Format the formatted Number as currency
  return formattedNumber.toLocaleString("en-US", {
    minimumFractionDigits: isFloat(formattedNumber) ? 2 : 0,
    maximumFractionDigits: isFloat(formattedNumber) ? 2 : 0,
  })
}
// Function to remove key-value pairs from object
// if the value is "" or null or undefined or []
export const cleanObject = (object) => {
  for (let key in object) {
    if (
      object[key] === "" ||
      object[key] == undefined ||
      object[key] == null ||
      (Array.isArray(object[key]) && object[key].length === 0)
    ) {
      delete object[key]
    }
  }

  return object
}

export function reduceArray(array, name, formatNum = true) {
  // if it is not an array or it is an array and it is length is 0 return 0
  if (!Array.isArray(array) || (Array.isArray(array) && array.length === 0))
    return 0

  const reducedValue = array.reduce(
    (total, item) => (name ? total + +item[name] : total + item),
    0
  )
  return formatNum ? formatNumber(reducedValue) : reducedValue
}
